// Tables grid for one external project. Click a card to view rows.

export const RemoteSchemaList = {
  hide: (el, s) => {
    const p = el.call('parseRemotePath')
    return !p.slug || !!p.table
  },
  flow: 'y',
  gap: 'A',

  LoadingState: {
    hide: (el, s) => !s.root?._extSchemaLoading,
    padding: 'C',
    textAlign: 'center',
    color: 'caption',
    fontSize: 'Z2',
    text: '{{ editor.remote.introspecting | polyglot }}'
  },

  ErrorState: {
    hide: (el, s) => !s.root?._extSchemaError,
    padding: 'A',
    round: 'radiusControl',
    background: 'overlayStrong',
    color: 'red',
    fontSize: 'Z2',
    text: (el, s) => s.root?._extSchemaError || ''
  },

  TableGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 'A',
    childExtends: 'RemoteTableCard',
    childrenAs: 'state',
    children: (el, s) => {
      const { slug } = el.call('parseRemotePath')
      if (!slug) return []
      const tables = s.root?._extSchemaBySlug?.[slug] || []
      return tables.map((t) => ({ ...t, slug }))
    }
  }
}
